import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      name: 'login',
      path: '/login',
      component: () => import('@/views/Login'),
      meta: { requiredAuth: false },
    },
    {
      name: 'signup',
      path: '/signup',
      component: () => import('@/views/Signup'),
      meta: { requiredAuth: false },
    },
    {
      name: 'forgot',
      path: '/forgot',
      component: () => import('@/views/Forgot'),
      meta: { requiredAuth: false },
    },
    {
      name: 'complete',
      path: '/complete',
      component: () => import('@/views/Complete'),
      meta: { requiredAuth: false },
    },
    {
      path: '/',
      component: () => import('@/views/Index'),
      meta: { requiredAuth: true },
      children: [
        {
          name: 'myAccount',
          path: 'account',
          meta: { requiredAuth: true },
          component: () => import('@/views/Account'),
        },
        {
          name: 'portfolio',
          path: '',
          meta: { requiredAuth: true },
          component: () => import('@/views/Portfolio'),
        },
        {
          name: 'dashboardDetail',
          path: 'detail',
          meta: { requiredAuth: true },
          component: () => import('@/views/DashboardDetail'),
        },
        {
          name: 'netWorth',
          path: '/networth',
          meta: { requiredAuth: true },
          component: () => import('@/views/NetWorth'),
        },
        {
          name: 'watchList',
          path: '/watchlist',
          meta: { requiredAuth: true },
          component: () => import('@/views/WatchList'),
        },
        {
          name: 'brokerAccounts',
          path: '/accounts',
          meta: { requiredAuth: true },
          component: () => import('@/views/BrokerAccounts'),
        },
        {
          name: 'input',
          path: '/input',
          meta: { requiredAuth: true },
          component: () => import('@/views/Input'),
        },
        {
          name: 'tax',
          path: 'tax',
          meta: { requiredAuth: true },
          component: () => import('@/views/Tax'),
        },
        {
          name: 'help',
          path: 'help',
          meta: { requiredAuth: true },
          component: () => import('@/views/Help'),
        },

        {
          name: 'admin',
          path: 'admin',
          meta: { requiredAuth: true },
          component: () => import('@/views/Admin'),
        },
      ],
    },
  ],
})
